const metricResetTypes = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
  NEVER: 'NEVER'
};

export default metricResetTypes;